import React from 'react';
import { withRouter } from 'react-router-dom';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';

import Masonry from 'react-masonry-component';
import Lightbox from 'react-image-lightbox';
import 'react-image-lightbox/style.css';

import { boardsActions } from '../../../store/boards';
import kara from '../../../assets/front/img/header/kara.jpg';

let images = [];

class Gallery extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            photoIndex: 0,
            isOpen: false,
        };
    }

    componentDidMount() {
        this.props.getDictionary(this.props.location.pathname.split('/')[1], this.props.location.pathname.split('/')[2]);
    }

    fileFilter(board) {
        const files = board.files.filter(file => file.type === "thumbnails");
        if (files.length !== 0) return files[0].name;
        return null;
    }

    onClick(index) {
        this.setState({ isOpen: true, photoIndex: index });
    }

    render() {
        if (!this.props.boards.boards && this.props.boards.length === 0) return null;
        //console.log(this.props);
        document.querySelector("main").scrollIntoView();

        const self = this;
        const { photoIndex, isOpen } = this.state;
        images = this.props.boards.boards.map(function (board) {
            let file = self.fileFilter(board);
            if (file !== null) return "/api/files/thumbnails/" + file;
            else return kara;
        });

        //{ self.fileFilter(board) && <img onClick={() => self.onClick(index)} src={`/api/files/thumbnails/${self.fileFilter(board)}`} className="img-fluid g-cursor-pointer" alt="kara" /> }
        //{ !self.fileFilter(board) && <img onClick={() => self.onClick(index)} src={kara} className="img-fluid g-cursor-pointer" alt="kara" /> }
        //<p className="text-center g-mt-10 g-mb-30 font-weight-bold">{board.title}</p>
        // style={{ backgroundImage: `url(/api/files/thumbnails/${self.fileFilter(board)})` }}

        return (
            <div className="col-lg-9">
                <Masonry options={{ columnWidth: ".masonry-grid-sizer", itemSelector: ".masonry-grid-item", percentPosition: true }} >
                    <div className="masonry-grid-sizer col-sm-1"></div>
                    <div className="masonry-grid row">
                        {this.props.boards.boards.map(function (board, index) {
                            return (
                                <div key={index} className="masonry-grid-item col-md-6">
                                    <article className="">
                                        <img onClick={() => self.onClick(index)} src={`/api/files/thumbnails/${self.fileFilter(board)}`} className="img-fluid g-cursor-pointer" alt="kara" />
                                        <p className="text-center g-mt-10 g-mb-30 g-color-primary font-weight-bold">{board.title}</p>
                                    </article>
                                </div>
                            )
                        })}
                    </div>
                </Masonry>

                <div>
                    {isOpen && (
                        <Lightbox
                            mainSrc={images[photoIndex]}
                            nextSrc={images[(photoIndex + 1) % images.length]}
                            prevSrc={images[(photoIndex + images.length - 1) % images.length]}
                            onCloseRequest={() => this.setState({ isOpen: false })}
                            onMovePrevRequest={() => this.setState({ photoIndex: (photoIndex + images.length - 1) % images.length }) }
                            onMoveNextRequest={() => this.setState({ photoIndex: (photoIndex + 1) % images.length }) }
                        />
                    )}
                </div>
            </div>
        )
    }
}

export default connect(
    state => state.boards,
    dispatch => bindActionCreators({ ...boardsActions }, dispatch)
)(withRouter(Gallery));



// WEBPACK FOOTER //
// ./src/pages/front/board/gallery.js